import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-65812196")

_pushScopeId("data-v-65812196")
const _hoisted_1 = { class: "personSelected" }
const _hoisted_2 = { class: "personSelected__name" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "small" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "type" }, " Взрослый ", -1)
const _hoisted_5 = { class: "personSelected__info" }
const _hoisted_6 = { class: "personSelected__info__blocksmall" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "burger icoBurger" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "personSelected__info__blocksmall__titleWrap " }, [
  /*#__PURE__*/_createVNode("div", { class: "icoOrderInfo personSelected__info__blocksmall__ico" }),
  /*#__PURE__*/_createVNode("div", { class: "title" }, " Информация ")
], -1)
const _hoisted_9 = { class: "listInfo" }
const _hoisted_10 = /*#__PURE__*/_createVNode("li", null, [
  /*#__PURE__*/_createVNode("span", null, " Дата рождения: "),
  /*#__PURE__*/_createTextVNode(" 14 июня 1962 г.")
], -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, " E-mail: ", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", null, " Телефон: ", -1)
const _hoisted_13 = { class: "personSelected__info__blocksmall" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "burger icoBurger" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "personSelected__info__blocksmall__titleWrap " }, [
  /*#__PURE__*/_createVNode("div", { class: "icoPasIco personSelected__info__blocksmall__ico" }),
  /*#__PURE__*/_createVNode("div", { class: "title" }, " Документ ")
], -1)
const _hoisted_16 = { class: "listInfo" }
const _hoisted_17 = { class: "personSelected__info" }
const _hoisted_18 = { class: "personSelected__info__blocksmall" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "burger icoBurger" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "personSelected__info__blocksmall__titleWrap " }, [
  /*#__PURE__*/_createVNode("div", { class: "icoBonusIco personSelected__info__blocksmall__ico" }),
  /*#__PURE__*/_createVNode("div", { class: "title" }, " Бонусная крата ")
], -1)
const _hoisted_21 = { class: "listInfo" }
const _hoisted_22 = {
  key: 0,
  class: "personSelected__info__blocksmall"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "burger icoBurger" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "personSelected__info__blocksmall__titleWrap " }, [
  /*#__PURE__*/_createVNode("div", { class: "icoPerCode personSelected__info__blocksmall__ico" }),
  /*#__PURE__*/_createVNode("div", { class: "title" }, " Бюджетные коды ")
], -1)
const _hoisted_25 = { class: "listInfo" }
const _hoisted_26 = {
  key: 1,
  class: "personSelected__info__blocksmall"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "burger icoBurger" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "personSelected__info__blocksmall__titleWrap " }, [
  /*#__PURE__*/_createVNode("div", { class: "icoPerCode personSelected__info__blocksmall__ico" }),
  /*#__PURE__*/_createVNode("div", { class: "title" }, " Персональные коды ")
], -1)
const _hoisted_29 = { class: "listInfo" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.personData.person) + " ", 1 /* TEXT */),
      _hoisted_3,
      _hoisted_4
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createVNode("ul", _hoisted_9, [
          _hoisted_10,
          _createVNode("li", null, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.personData.email), 1 /* TEXT */)
          ]),
          _createVNode("li", null, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.personData.phone), 1 /* TEXT */)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _createVNode("ul", _hoisted_16, [
          _createVNode("li", null, _toDisplayString(_ctx.personData.document), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createVNode("ul", _hoisted_21, [
          _createVNode("li", null, _toDisplayString(_ctx.personData.bonusCard), 1)
        ])
      ]),
      (_ctx.budgetCodes && _ctx.budgetCodes.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_22, [
            _hoisted_23,
            _hoisted_24,
            _createVNode("ul", _hoisted_25, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.budgetCodes, (item) => {
                return (_openBlock(), _createBlock("li", {
                  key: item.codeId
                }, [
                  _createVNode("span", null, _toDisplayString(item.codeName) + ": ", 1),
                  _createTextVNode(" " + _toDisplayString(item.codeValue), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("", true),
      (!!_ctx.personCodes && _ctx.personCodes.length > 0)
        ? (_openBlock(), _createBlock("div", _hoisted_26, [
            _hoisted_27,
            _hoisted_28,
            _createVNode("ul", _hoisted_29, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.personCodes, (item) => {
                return (_openBlock(), _createBlock("li", {
                  key: item.codeId
                }, [
                  _createVNode("span", null, _toDisplayString(item.codeName) + ": ", 1),
                  _createTextVNode(" " + _toDisplayString(item.codeValue), 1 /* TEXT */)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})